"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const map_1 = __importDefault(require("lodash/map"));
const isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
const mapValues_1 = __importDefault(require("lodash/mapValues"));
const isArray_1 = __importDefault(require("lodash/isArray"));
const each_1 = __importDefault(require("lodash/each"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const reduce_1 = __importDefault(require("lodash/reduce"));
const reselect_1 = require("reselect");
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const recompose_1 = require("recompose");
const random_1 = require("@zedoc/random");
const questionnaire_1 = require("@zedoc/questionnaire");
const text_1 = require("@zedoc/text");
const selectors_1 = require("@zedoc/selectors");
const QuestionnaireContext_1 = __importStar(require("./QuestionnaireContext"));
const SelectorsHub_1 = __importDefault(require("./SelectorsHub"));
const propTypes_1 = require("./propTypes");
const getRandomisedChoices = (choices, question, answersSheetId) => {
    const order = new Map();
    let seed = 1;
    (0, each_1.default)(choices, (choice) => {
        if (!question) {
            return;
        }
        seed += (0, reduce_1.default)(answersSheetId, (sum, c) => sum + c.charCodeAt(0), 0);
        seed += (0, reduce_1.default)(question.id, (sum, c) => sum + c.charCodeAt(0), 0);
        const getRandomNumber = () => {
            const x = Math.sin(seed) * 10000;
            return x - Math.floor(x);
        };
        order.set(choice, getRandomNumber());
    });
    return (0, sortBy_1.default)(choices, (choice) => order.get(choice));
};
class Question extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.getContext = (0, reselect_1.createSelector)((0, selectors_1.argument)(0, 'context'), (0, selectors_1.argument)(1), // question
        (context, question) => {
            const newContext = Object.assign(Object.create(context), {
                question,
                questionId: !question.isSection() && question.id,
            });
            return newContext;
        });
        this.handleAppend = this.handleAppend.bind(this);
    }
    handleAppend() {
        const { dispatch, question, context, contextOptions } = this.props;
        if (contextOptions && contextOptions.disabled) {
            return;
        }
        if (!question) {
            return;
        }
        if (!question.isCollection()) {
            return;
        }
        if (dispatch) {
            dispatch((_, getState) => {
                const evaluationScope = context.select.evaluationScope(context.scopeKey)(getState());
                const elementId = random_1.Random.id();
                const initialValues = evaluationScope
                    .getOrCreateSubScope(question.id)
                    .getOrCreateSubScope(elementId)
                    .getInitialValues();
                dispatch(context.insertElement(elementId, question.id, initialValues));
            });
        }
    }
    render() {
        const _a = this.props, { id, children, elements, question, disabled, valueSet, choices, iframeUrl, dependencies, contextOptions } = _a, other = __rest(_a, ["id", "children", "elements", "question", "disabled", "valueSet", "choices", "iframeUrl", "dependencies", "contextOptions"]);
        if (!question) {
            return null;
        }
        const childrenProps = Object.assign(Object.assign({}, other), { elements,
            question,
            valueSet,
            choices,
            iframeUrl,
            dependencies, questionId: id, handleChange: this.handleChange, handleAppend: this.handleAppend });
        // NOTE: Can either be disabled explicitly,
        //       via context property, or it can be
        //       a direct question property.
        if (disabled ||
            (contextOptions && contextOptions.disabled) ||
            question.shouldDisableInput()) {
            childrenProps.disabled = true;
        }
        return (react_1.default.createElement(QuestionnaireContext_1.default.Provider, { value: this.getContext(this.props, question) }, children(childrenProps)));
    }
}
Question.propTypes = {
    id: prop_types_1.default.string.isRequired,
    children: prop_types_1.default.func.isRequired,
    dispatch: prop_types_1.default.func,
    elements: prop_types_1.default.arrayOf(prop_types_1.default.string),
    question: prop_types_1.default.instanceOf(questionnaire_1.Question),
    valueSet: propTypes_1.ValueSetPropTypes,
    choices: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        // eslint-disable-next-line react/forbid-prop-types
        value: prop_types_1.default.any,
        label: prop_types_1.default.string,
    })).isRequired,
    iframeUrl: prop_types_1.default.string,
    // eslint-disable-next-line react/forbid-prop-types
    dependencies: prop_types_1.default.any,
    context: prop_types_1.default.instanceOf(SelectorsHub_1.default).isRequired,
    disabled: prop_types_1.default.bool,
    contextOptions: prop_types_1.default.shape({
        disabled: prop_types_1.default.bool,
    }),
};
Question.defaultProps = {
    dispatch: null,
    elements: null,
    question: null,
    valueSet: null,
    iframeUrl: null,
    dependencies: null,
    disabled: null,
    contextOptions: null,
};
exports.default = (0, recompose_1.compose)((0, QuestionnaireContext_1.withContext)(), (0, react_redux_1.connect)(() => {
    const selectQuestionnaire = (0, selectors_1.higherOrderSelector)((0, selectors_1.property)('context'), (context) => context.select.questionnaire());
    const selectOriginalQuestion = (0, reselect_1.createSelector)((0, selectors_1.property)('id'), selectQuestionnaire, (id, questionnaire) => questionnaire && questionnaire.getQuestionById(id));
    const selectQuestionProperties = (0, selectors_1.higherOrderSelector)((0, selectors_1.property)('context'), (0, selectors_1.property)('id'), (context, id) => context.createPropertiesSelector(id));
    const selectAnswersSheetId = (0, reselect_1.createSelector)((0, selectors_1.higherOrderSelector)((0, selectors_1.property)('context'), (context) => context.select.meta()), (meta) => meta && meta.answersSheetId);
    const selectQuestion = (0, reselect_1.createSelector)(selectQuestionProperties, selectOriginalQuestion, (properties, question) => {
        if (!question) {
            return question;
        }
        return Object.assign(Object.create(question), properties);
    });
    const selectValueSet = (0, reselect_1.createSelector)((0, reselect_1.createSelector)((state, props) => props.context.select.evaluationScope(props.context.scopeKey)(state), selectOriginalQuestion, (evaluationScope, question) => {
        if (question && question.shouldEvaluateValueSet()) {
            // NOTE: The second alternative is only used for compatibility
            //       with older versions of project wizard. It will be removed
            //       as soon as project wizard is migrated.
            const formula = question.settings &&
                (question.settings.valueSetFormula || question.settings.formula);
            if (!formula) {
                return null;
            }
            const result = questionnaire_1.Formula.create(formula).evaluate(evaluationScope);
            if (!result.error) {
                return result.value;
            }
        }
        return null;
    }), (0, reselect_1.defaultMemoize)(selectors_1.identity, isEqual_1.default));
    const createDependencySelectorCreator = (context) => (dependency) => {
        const formula = questionnaire_1.Formula.create(dependency);
        return (0, reselect_1.createSelector)(context.select.evaluationScope(context.scopeKey), (scope) => formula.evaluate(scope));
    };
    const selectDependencies = (0, selectors_1.higherOrderSelector)((0, selectors_1.property)('dependencies'), (0, selectors_1.property)('context'), (dependencies, context) => {
        if ((0, isArray_1.default)(dependencies)) {
            return (0, reselect_1.createSelector)((0, reselect_1.createSelector)(...(0, map_1.default)(dependencies, createDependencySelectorCreator(context)), (...args) => args), (0, reselect_1.defaultMemoize)(selectors_1.identity, isEqual_1.default));
        }
        if ((0, isPlainObject_1.default)(dependencies)) {
            return (0, reselect_1.createSelector)((0, reselect_1.createStructuredSelector)((0, mapValues_1.default)(dependencies, createDependencySelectorCreator(context))), (0, reselect_1.defaultMemoize)(selectors_1.identity, isEqual_1.default));
        }
        return (0, selectors_1.constant)();
    });
    const selectQuestionChoices = (0, reselect_1.createSelector)(selectQuestion, selectValueSet, selectAnswersSheetId, (question, valueSet, answersSheetId) => {
        if (!question) {
            return [];
        }
        const choices = question.getChoices(valueSet);
        if (question.useRandomisedResponsesOrder()) {
            return getRandomisedChoices(choices, question, answersSheetId);
        }
        return choices;
    });
    const selectIframeUrl = (0, reselect_1.createSelector)((0, selectors_1.higherOrderSelector)((0, selectors_1.property)('context'), (context) => context.select.formValues()), selectQuestion, (formValues, question) => {
        if (!question || !question.isIframe()) {
            return null;
        }
        const { url, query } = question.getIframeParams(formValues);
        if (query) {
            return `${url}?q=${(0, text_1.strToBase64Url)(JSON.stringify(query))}`;
        }
        return url;
    });
    return (0, reselect_1.createStructuredSelector)({
        question: selectQuestion,
        valueSet: selectValueSet,
        choices: selectQuestionChoices,
        iframeUrl: selectIframeUrl,
        dependencies: selectDependencies,
        elements: (0, selectors_1.higherOrderSelector)((0, selectors_1.property)('id'), (0, selectors_1.property)('context'), selectQuestionnaire, (id, context, questionnaire) => {
            const question = questionnaire && questionnaire.getQuestionById(id);
            if (!question || !question.isCollection()) {
                return (0, selectors_1.constant)(null);
            }
            return context.createFormValueSelector(`${id}._elementsOrder`);
        }),
        contextOptions: (0, selectors_1.higherOrderSelector)((0, selectors_1.property)('context'), (context) => context.select.options()),
    });
}))(Question);
//# sourceMappingURL=Question.js.map